import { Icon } from '@chakra-ui/react';

export default function SFCustomersFilledIcon(props) {
  return (
    <Icon
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill='currentColor'
        d='M16.078 12.148c-1.68 0-3.125-1.5-3.125-3.437 0-1.914 1.453-3.375 3.125-3.375 1.664 0 3.117 1.43 3.117 3.36 0 1.952-1.445 3.452-3.117 3.452m-9 .18c-1.453 0-2.719-1.312-2.719-2.992 0-1.672 1.274-2.938 2.72-2.938 1.452 0 2.718 1.235 2.718 2.922 0 1.696-1.258 3.008-2.719 3.008m-4.351 7.055c-.993 0-1.375-.39-1.375-1.102 0-2.156 2.203-4.758 5.726-4.758 1.453 0 2.57.43 3.445 1.008-1.687 1.297-2.68 3.672-1.867 4.852zm8.437 0c-1.226 0-1.664-.352-1.664-1.04 0-2.015 2.523-4.796 6.57-4.796 4.055 0 6.578 2.781 6.578 4.797 0 .687-.437 1.039-1.671 1.039z'
      />
    </Icon>
  );
}
